import {
  SimpleShowLayout,
  Show,
  TextField,
  DateField,
  ReferenceField,
  Datagrid,
  ArrayField,
  ReferenceArrayField,
  SingleFieldList,
  Labeled,
  useShowController,
} from "react-admin";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { CampaignSubTypes, RankingType } from "utils/constants";
import { settings } from "app";
import RankingsList from "../components/RankingsList";
import React from "react";
import CitizenshipFiled from "../components/Fileds/CitizenshipFiled";
import CampaignTypeField from "../components/Fileds/CampaignTypeField";
import DegreeField from "../components/Fileds/DegreeField";
import DirectionField from "../components/Fileds/DirectionField";
import ChildCampaignField from "../components/Fileds/ChildCampaignField";
import SpecialitiesArrayField from "../components/Fileds/SpecialitiesField";
import NameBgField from "../components/Fileds/NameBgField";
import NameEnField from "../components/Fileds/NameEnField";
import TaxesShow from "../components/TaxesShow";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import FinalizeCampaignButton from "../components/FinalizeCampaignButton";
import { documentRequests } from "api/documentsApi";
import { paymentRequests } from "api/paymentApi";
import { SectionTitle } from "features/SectionTitle";

const ShowPaidCampaign = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { record } = useShowController();
  const isFinished = record?.isFinished;

  return (
    <Show actions={<BackButtonToolbar />}>
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на български език">
              <NameBgField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на английски език">
              <NameEnField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Дата на създаване">
              <DateField
                source="createdOn"
                locales="bg-BG"
                showTime
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Гражданство">
              <CitizenshipFiled isArray />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Начало на регистрация">
              <DateField
                source="registrationFrom"
                locales="bg-BG"
                showTime
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Край на регистрация">
              <DateField
                source="registrationTo"
                locales="bg-BG"
                showTime
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Тип">
              <CampaignTypeField subTypeId={CampaignSubTypes.Paid} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="ОКС">
              <DegreeField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Направление">
              <DirectionField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <ChildCampaignField childCampaignSubTypeId={CampaignSubTypes.Regular} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            {isFinished && (
              <Typography
                color={"error"}
                fontWeight={"bold"}
                mb={1}
              >
                Кампанията е завършена
              </Typography>
            )}
            <SecuredComponent permission={permissions.canFinishCampaigns}>
              <FinalizeCampaignButton
                id={record?.id}
                disabled={isFinished}
                campaignName={record?.nameBg}
              />
            </SecuredComponent>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SpecialitiesArrayField />
      <SimpleShowLayout>
        <SectionTitle
          title="Декларации"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Box sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}>
          <ArrayField
            source="declarationDtos"
            label=" "
          >
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
              sx={settings.style.secondaryDatagrid}
            >
              <ReferenceField
                source="declarationId"
                label="Декларация"
                reference={documentRequests.getDeclarationsSelect()}
              >
                <TextField
                  label="Декларация"
                  source="name"
                />
              </ReferenceField>
              <CitizenshipFiled
                label="Гражданство"
                isArray={false}
              />
            </Datagrid>
          </ArrayField>
        </Box>
      </SimpleShowLayout>

      {/* <TaxesShow /> */}

      <RankingsList
        isFinished={isFinished}
        rankingTypes={[RankingType.Paid]}
      />

      <SimpleShowLayout>
        <SectionTitle
          title="Ibans"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Box sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}>
          <Labeled label="Iban">
            <ReferenceArrayField
              source="ibanIds"
              reference={paymentRequests.getIbansSelect()}
            >
              <SingleFieldList
                label="Iban"
                source="name"
              />
            </ReferenceArrayField>
          </Labeled>
        </Box>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowPaidCampaign;
